/**
 * @file GeneralSocialRiskRegisterView.jsx
 * @author Fernando Ruano
 * @description General Social Risk Register View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';

// Components
import DashboardCard from 'components/DashboardCard';
import DashboardProgress from 'components/Charts/DashboardProgress';
import styleGuideColors from 'commons/styleGuideColors';

/**
 * General Social Risk Register View
 * @param { Object } dashboardStaffActions - DashboardStaff Actions.
 * @return { Node } React node.
 */

function GeneralSocialRiskRegisterView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const [chartData, setChartData] = useState(null);

  const { getGeneralSocialRiskRegister } = dashboardStaffActions;

  const getProgressData = (key, color, total) => {
    return {
      label: translate(`commons.${key.coincide_registros}`),
      value: ((key.cantidad * 100) / total).toFixed(3).slice(0, -1),
      title: key.cantidad,
      color,
      cantidad: key.cantidad,
      classification: key.coincide_registros
    };
  };

  const onGetData = (_, resp) => {
    if (resp?.data && resp?.data?.length !== 0) {
      let data = {};
      let progress = {};
      let max = {};
      let total = 0;
      resp?.data.forEach(({ cantidad }) => {
        total += cantidad;
      });

      resp?.data?.forEach((itm) => {
        if (itm.coincide_registros === 'Si') {
          progress = getProgressData(
            itm,
            styleGuideColors.baxterBrandTeal,
            total
          );
        } else {
          max = getProgressData(itm, styleGuideColors.alertError, total);
        }
      });
      data = {
        progress,
        max
      };
      setChartData(data);
    } else {
      setChartData([]);
    }
  };

  useEffect(() => {
    setChartData(null);
    getGeneralSocialRiskRegister({ clinicId }, onGetData);
  }, [translate, clinicId]);

  const handleDetailClick = (section) => {
    const { cantidad: totalItems, classification } = chartData[section];
    history.push(
      `/main/dashboard-detail/general-social-risk-register/${classification}/${totalItems}`
    );
  };

  return (
    <DashboardCard id="F42" loading={!chartData}>
      <DashboardProgress
        title={translate('dashboardStaff.psychosocialGeneralRisk')}
        max={chartData?.max}
        progress={chartData?.progress}
        onDetailClick={handleDetailClick}
      />
    </DashboardCard>
  );
}

/**
 * Component definition of proptypes.
 */
GeneralSocialRiskRegisterView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getGeneralSocialRiskRegister: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default GeneralSocialRiskRegisterView;
